import React from 'react';
import { Provider } from 'react-redux';
import ConversationListContainer from '../containers/conversation_list_container';
import ConversationCreatorContainer from '../containers/conversation_creator_container';
import ConversationDetailsContainer from '../containers/conversation_details_container';
import MessageListContainer from '../containers/message_list_container';
import DrawerNavContainer from '../containers/drawer_nav_container';
import MainNavContainer from '../containers/main_nav_container';
import MessageCreatorContainer from '../containers/message_creator_container';
import ConversationsApp from '../utils/conversations';

class ConversationsComponent extends React.Component {
  componentDidMount() {
    if ('Notification' in window) {
      Notification.requestPermission();
    }
  }

  render() {
    const store = ConversationsApp.createStore(this.props.initialData);

    return (
      <Provider store={store}>
        <div className="conversations-columns row">
          <div className="col-xs-12 col-md-3 conversations-nav">
            <DrawerNavContainer />
            <ConversationListContainer />
          </div>
          <ConversationCreatorContainer />
          <MessageListContainer />
          <MainNavContainer />
          <MessageCreatorContainer />
          <ConversationDetailsContainer />
        </div>
      </Provider>
    );
  }
}

export default ConversationsComponent;
